import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'enum',
  pure: true,
})
export class EnumPipe implements PipeTransform {
  transform(value: string, map: { [key: string]: string }): string {
    return map[value] || value;
  }
}
